import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPelletizingDisc = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 60,
	viewBox: "0 0 100.0 60.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 0.0 60.0 L 100.0 60.0 L 80.0 0.0 L 20.0 0.0 Z M 5.0 45.0 L 95.0 45.0 M 15.0 45.0 L 15.0 60.0 M 85.0 45.0 L 85.0 60.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("ellipse", {
		cx: 50,
		cy: 22.5,
		rx: 10,
		ry: 10,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgPelletizingDisc;
